"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.payment.confirmed': 'Payment Confirmed',
    'route.payment.list': 'Payments',
    'route.payment.preview': 'Payment Details',
};
